import store from '../store/premiumFlightStore';
import { mutatorAction } from 'satcheljs';
import { GetUserPersistedFlightResponse } from 'owa-premium-flight/lib/services/GetUserPersistedFlightResponse';

export default mutatorAction('persistResponse', function persistResponse(
    response: GetUserPersistedFlightResponse
) {
    if (response.flightNames) {
        store.flightNames = response.flightNames;
    }
    store.isInit = true;
});
